import React, { useState } from "react";
import { Formik } from "formik";
import Edit from "../../../assets/images/editinput.svg";
import { Tooltip } from '@appkit4/react-components/tooltip';

import { TextArea } from "@appkit4/react-components/field";
import { Tabs, Tab } from "@appkit4/react-components/tabs";
import ConfermationModal from "../../Common/DeleteModal";
import displayToastMessage from "../../Common/Alert/displayToastMessage";
import { approvalViewIssue } from "../../../services/ApiService";
import PropTypes from "prop-types";
import useHttp from "../../../hooks/useHttp";
import APIService from "../../../services/apiAxiosService";
export default function IssueUpdate(prop) {
  let { updateIssueId, View } = prop;
  const [conformationVisible, setConformationVisible] = useState(false);
  const [comment, setComment] = useState("");
  const [currentTab, setCurrentTab] = useState("1");
  const [save, setSave] = useState(false);
  const [rejectValue, setRejectValue] = useState("");
  const [comments, setComments] = useState("");
  const [commentsFormat, setCommentsFormat] = useState(false);
  const { sendRequest: approvalViewIssueAPI } = useHttp();
  const { sendRequest: downloadAPI } = useHttp();

  const handelSubmit = (values) => {
    if (!commentsFormat) {
      let issueData = {
        Issue_ID: updateIssueId && updateIssueId.issue_id,
        Vendor_ID: updateIssueId && updateIssueId.vendor_id,
        Issue_Comments: comments,
        Role_ID: Number(sessionStorage.getItem("roleId")),
        Created_By: Number(sessionStorage.getItem("userId")),
        email:sessionStorage.getItem("email"),
        vendorName:updateIssueId.vendor_name,
        vendorEmail:updateIssueId.vendoremail,
        assessoremail:updateIssueId.assessoremail,
        issue_action_id:updateIssueId.issue_action_id
      };
      if (rejectValue != 4) {
        issueData.approval_requestId = 3;
      } else {
        issueData.approval_requestId = rejectValue;
      }
      setComment(issueData);
      setConformationVisible(true);
    }
  };

  const handleTabs = (e, v) => {
    setCurrentTab(v);
  };

  const handelCancel = () => {
    setConformationVisible(false);
  };
  const handleReject = (value) => {
    if (!commentsFormat) {
      setConformationVisible(true);
      setSave(true);
      setRejectValue(value);
    }
  };
  const handelConform = async ({ resetForm }) => {
    await approvalViewIssueAPI(
      APIService.approvalViewIssue(comment),
      (data) => {
        if (data.CODE) {
          setConformationVisible(false);
          prop.handleBack();
          displayToastMessage(data.MSG, "success");
        } else {
          let Msg = "Action failed. Please try again!";
          setConformationVisible(false);
          prop.handleBack();
          displayToastMessage(Msg, "error");
        }
      },
      (error) => {
        console.log("Error", error);
        setConformationVisible(false);
        prop.handleBack();
        let Msg = "Action failed. Please try again!";
        displayToastMessage(Msg, "error");
      }
    );
  };
  let initialValues = {
    Comment: "",
  };
  function formatDate(date) {
    let d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  const handleChangeComment = (e) => {
    if (e.search(/[^()0-9a-zA-Z,. ]/) === -1) {
      setCommentsFormat(false);
    } else {
      setComments();
      setCommentsFormat(true);
    }
    setComments(e);
  };

  const splitData=updateIssueId?.evidencedetails?.split(',');

  const downloadResponseHandler = (result, fileName) => {
    if (result) {
      const blob = new Blob([result?.data], {
        type: "application/octet-stream",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
      displayToastMessage("File Downloaded successfully", "success");
    }
  };

  const getDownloadFile = async (data, fileName) => {
    await downloadAPI(
      APIService.downloadFile(data,'issue'),
      (res) => downloadResponseHandler(res, fileName),
      (err) => {
        let MSG = "Something went wrong, Please try again!";
        displayToastMessage(MSG, "error");
      },
      true
    );
  };

  return (
    <div>
      <div className="row text-end">
        <div className="col-md-12 ">
          <span className="cv-input-label  me-5">
            Issue ID : {"ISSUE"}
            {updateIssueId && updateIssueId.issue_id}{" "}
          </span>
          <span className="cv-input-label me-4">
            Status :{" "}
            <span className="upadte-status Close-status status-pading me-4">
              {" "}
              {updateIssueId?._status}
            </span>
          </span>
          <span
            className="Appkit4-icon icon-arrow-left-outline pointer back-fill"
            onClick={prop.handleBack}
          ></span>
        </div>
      </div>

      <Formik initialValues={initialValues} onSubmit={handelSubmit}>
        {(props) => {
          const {
            values,
            handleChange,
            handleBlur,
            handleSubmit,
          } = props;
          return (
            <div className="">
              {updateIssueId && (
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label htmlFor="nameEditIssue" className="cv-input-label">
                          Third Party Name <span className="asterisk-required">*</span>
                        </label>
                        <input
                          name="ThirdPartyName"
                          type="text"
                          id="nameEditIssue"
                          value={updateIssueId.vendor_name}
                          onChange={handleChange("ThirdPartyName")}
                          onBlur={handleBlur}
                          className="cv-input-field"
                          placeholder="Please enter third party name"
                          disabled
                        />
                      </div>
                    </div>

                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label htmlFor="assessmentEditIssue" className="cv-input-label">
                          Assessment <span className="asterisk-required">*</span>
                        </label>
                        <input
                          name="AssessmentID"
                          type="text"
                          id="assessmentEditIssue"
                          value={updateIssueId.assessment_name}
                          onChange={handleChange("AssessmentID")}
                          onBlur={handleBlur}
                          className="cv-input-field"
                          placeholder="Please enter assessment"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label htmlFor="detailsEditIssue" className="cv-input-label">
                          Issue Details{" "}
                          <span className="asterisk-required">*</span>
                        </label>
                        <input
                          name="IssueDetails"
                          type="text"
                          id="detailsEditIssue"
                          value={updateIssueId.issue_details}
                          onChange={handleChange("IssueDetails")}
                          onBlur={handleBlur}
                          className="cv-input-field pl-1"
                          placeholder="Please enter issue details"
                          disabled
                        />
                        <img alt="edit" src={Edit} className="edit-input" />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label htmlFor="creationEditIssue" className="cv-input-label">
                          Creation Date{" "}
                          <span className="asterisk-required">*</span>
                        </label>
                        <input
                          name="CreationDate"
                          type="date"
                          id="creationEditIssue"
                          value={formatDate(updateIssueId.created_date)}
                          onChange={handleChange("CreationDate")}
                          onBlur={handleBlur}
                          className="cv-input-field"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label htmlFor="IssueDueDateEditIssue" className="cv-input-label">
                          Issue Due Date{" "}
                          <span className="asterisk-required">*</span>
                        </label>
                        <input
                          name="IssueDueDate"
                          type="date"
                          id="IssueDueDateEditIssue"
                          value={formatDate(updateIssueId.issuedue_date)}
                          onChange={handleChange("IssueDueDate")}
                          onBlur={handleBlur}
                          className="cv-input-field"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mt-3">
                    <Tabs
                      defaultValue={currentTab}
                      value={currentTab}
                      onChange={handleTabs}
                      className="a-tab-item-padding-10"
                    >
                      {/* <Tab value="1" label="Classification">
                        <div className="col-sm-6 mt-3">
                          <div className="cv-input-field-container">
                            <label className="cv-input-label">
                              Issue Type <span className="asterisk-required">*</span>
                            </label>
                            <Select
                              className="cv-input-field"
                              onBlur={handleBlur}
                              data={dropdownData}
                              onSelect={handleChange("IssueType")}
                              name="IssueType"
                              placeholder="Select issue type"
                              value={updateIssueId.issuetype}
                              disabled
                            ></Select>
                          </div>
                        </div>

                        <div className="col-sm-6 mt-2">
                          <div className="cv-input-field-container">
                            <label className="cv-input-label">
                              Rating <span className="asterisk-required">*</span>
                            </label>

                            <input
                              name="Rating"
                              type="text"
                              id="Rating"
                              value={updateIssueId.issue_priority}
                              onChange={handleChange("Rating")}
                              onBlur={handleBlur}
                              className="cv-input-field"
                              placeholder="Please enter rating"
                              disabled
                            />
                          </div>
                        </div>
                      </Tab> */}
                      {/* <Tab value="2" label="Risk Mapping">
                        <div className="col-sm-6 mt-3">
                          <div className="cv-input-field-container">
                            <label className="cv-input-label">Risk ID</label>

                            <input
                              name="RiskID"
                              type="text"
                              id="RiskID"
                              value={updateIssueId.risk_id}
                              onChange={handleChange("RiskID")}
                              onBlur={handleBlur}
                              className="cv-input-field"
                              placeholder="Please enter risk id"
                              disabled
                            />
                          </div>
                        </div>
                        <div className="col-sm-6 mt-2">
                          <div className="cv-input-field-container">
                            <label className="cv-input-label">Risk Name </label>
                            <input
                              name="RiskName"
                              type="text"
                              id="RiskName"
                              value={updateIssueId.service_name}
                              onChange={handleChange("riskName")}
                              onBlur={handleBlur}
                              className="cv-input-field pl-1"
                              placeholder="Please enter risk name"
                              disabled
                            />
                            <img alt="edit" src={Edit} className="edit-input" />
                          </div>
                        </div>
                      </Tab> */}
                      <Tab value="3" label="Control/Question Mapping">
                        <div className="col-sm-6 mt-3">
                          <div className="cv-input-field-container">
                            <label htmlFor="ControlQuestionIDEditIssue" className="cv-input-label">
                              Control/ Question ID <span className="asterisk-required">*</span>
                            </label>

                            <input
                              name="ControlName"
                              type="text"
                              id="ControlQuestionIDEditIssue"
                              placeholder="ControlQuestionID"
                              value={updateIssueId.controlquestionid}
                              onChange={handleChange("ControlQuestionID")}
                              onBlur={handleBlur}
                              className="cv-input-field ml-3"
                            />
                            <img alt="edit" src={Edit} className="edit-input" />
                          </div>
                        </div>

                        <div className="col-sm-6 mt-2">
                          <div className="cv-input-field-container">
                            <label htmlFor="ControlNameEditIssue" className="cv-input-label">
                              Control Name{" "}
                              <span className="asterisk-required">*</span>
                            </label>
                            <input
                              name="ControlName"
                              type="text"
                              id="ControlNameEditIssue"
                              value={updateIssueId.control_name}
                              onChange={handleChange("ControlName")}
                              onBlur={handleBlur}
                              className="cv-input-field pl-1"
                              placeholder="Please enter control name"
                              disabled
                            />
                            <Tooltip
        trigger='hover'
        position='top-left'
        distance={4}
        id="tooltipDesc"
        appendAfterTarget={true}
        content={updateIssueId.control_name}
      >
                            <img alt="edit" src={Edit} className="edit-input" /></Tooltip>
                          </div>
                        </div>
                      </Tab>
                      <Tab value="4" label="Remediation Plan">
                        <div className="col-sm-6 mt-3">
                          <div className="cv-input-field-container">
                            <label htmlFor="RemediationPlanEditIssue" className="cv-input-label">
                              Remediation Plan{" "}
                              <span className="asterisk-required">*</span>
                            </label>
                            <textarea
                              name="RemediationPlan"
                              type="text"
                              id="RemediationPlanEditIssue"
                              value={updateIssueId.remediationplan}
                              onChange={handleChange("RemediationPlan")}
                              onBlur={handleBlur}
                              className="cv-input-field pl-1"
                              placeholder="Please enter remediaation plan"
                              disabled
                            />
                           <Tooltip
        trigger='hover'
        position='top-left'
        distance={4}
        id="tooltipDesc"
        appendAfterTarget={true}
        content={updateIssueId.remediationplan}
      >
                            <img alt="edit" src={Edit} className="edit-input" /></Tooltip>
                          </div>
                        </div>
                         <div className="col-sm-6 mt-3">
                         <label htmlFor="RemediationPlanEditIssue" className="cv-input-label">
                         Evidence </label>
                        {splitData?.map((val,i)=>{
                          return  <div onClick={()=>getDownloadFile(val.split('#$%')[1],val.split('#$%')[0])} className="hyperText">{val.split('#$%')[0]} </div>

                          })}
                          </div>
                      </Tab>
                      <Tab value="5" label="Add Action">
                        <div className="col-sm-6 mt-3">
                          <div className="cv-input-field-container">
                            <label htmlFor="titleEditIssue" className="cv-input-label">
                              Title <span className="asterisk-required">*</span>
                            </label>
                            <input
                              name="Title"
                              type="text"
                              id="titleEditIssue"
                              value={updateIssueId.title_action}
                              onChange={handleChange("Title")}
                              onBlur={handleBlur}
                              className="cv-input-field pl-1"
                              placeholder="Please enter title"
                              disabled
                            />

                            <img alt="edit" src={Edit} className="edit-input" />
                          </div>
                        </div>
                        <div className="col-sm-6 mt-2">
                          <div className="cv-input-field-container">
                            <label htmlFor="DescriptionEditIssue" className="cv-input-label">
                              Description{" "}
                              <span className="asterisk-required">*</span>
                            </label>
                            <input
                              name="Description"
                              type="Description"
                              id="DescriptionEditIssue"
                              value={updateIssueId.description}
                              onChange={handleChange("Description")}
                              onBlur={handleBlur}
                              className="cv-input-field pl-1"
                              placeholder="Please enter description"
                              disabled
                            />
                            <img alt="edit" src={Edit} className="edit-input" />
                          </div>
                        </div>
                        <div className="col-sm-6 mt-2">
                          <div className="cv-input-field-container">
                            <label htmlFor="StartDateEditIssue" className="cv-input-label">
                              Start Date{" "}
                              <span className="asterisk-required">*</span>
                            </label>
                            <input
                              name="StartDate"
                              type="date"
                              id="StartDateEditIssue"
                              value={formatDate(updateIssueId.startdate)}
                              onChange={handleChange("StartDate")}
                              onBlur={handleBlur}
                              className="cv-input-field"
                              disabled
                            />
                          </div>
                        </div>
                        <div className="col-sm-6 mt-2">
                          <div className="cv-input-field-container">
                            <label htmlFor="EndDateEditIssue" className="cv-input-label">
                              End Date{" "}
                              <span className="asterisk-required">*</span>
                            </label>
                            <input
                              name="EndDate"
                              type="date"
                              id="EndDateEditIssue"
                              value={formatDate(updateIssueId.enddate)}
                              onChange={handleChange("EndDate")}
                              onBlur={handleBlur}
                              className="cv-input-field"
                              disabled
                            />
                          </div>
                        </div>
                        <div className="col-sm-6 mt-2">
                          <div className="cv-input-field-container">
                            <label htmlFor="WorkPerformedEditIssue" className="cv-input-label">
                              Work Performed{" "}
                              <span className="asterisk-required">*</span>
                            </label>
                            <input
                              name="WorkPerformed"
                              type="text"
                              id="WorkPerformedEditIssue"
                              value={updateIssueId.workperformed}
                              onChange={handleChange("WorkPerformed")}
                              onBlur={handleBlur}
                              className="cv-input-field pl-1"
                              placeholder="Please enter work performed"
                              disabled
                            />
                            <img alt="edit" src={Edit} className="edit-input" />
                          </div>
                        </div>
                      </Tab>
                      <Tab value="6" label="Approval">
                        <div className="col-sm-6 mt-3">
                          <div className="cv-input-field-container">
                            <label htmlFor="ApprovalEditIssue" className="cv-input-label">
                              Approval{" "}
                              <span className="asterisk-required">*</span>
                            </label>

                            <input
                              name="Approval"
                              type="text"
                              id="ApprovalEditIssue"
                              value={updateIssueId.analyst_name}
                              onChange={handleChange("Approval")}
                              onBlur={handleBlur}
                              className="cv-input-field"
                              placeholder="Please enter approval"
                              disabled
                            />
                          </div>
                        </div>
                      </Tab>
                    </Tabs>
                  </div>
                  <div className="row mt-4">
                    <div className="col-sm-6 mt-1">
                      <label className="cv-input-label">Comment</label>
                      <TextArea
                        name="Comment"
                        type="text"
                        id="Comment"
                        value={comments?comments:updateIssueId.analystcomment}
                        onChange={handleChangeComment}
                        className="cv-input-field input-field-border"
                      />
                      {commentsFormat && (
                        <label className="requiredComments">
                          Only alphabets and some special characters are allowed
                          for this field
                        </label>
                      )}
                    </div>
                  </div>

                  <div className="options-container">
                    {prop.mode === "create" && (
                      <button type="submit" className="save-button m-l-2">
                        Initiate Issue
                      </button>
                    )}
                    {View && (
                      <button type="submit" className="save-button m-l-2">
                        Approve
                      </button>
                    )}
                    {View && (
                      <button
                        type="submit"
                        className="save-button m-l-2"
                        onClick={() => handleReject("4")}
                      >
                        Reject
                      </button>
                    )}
                    <button
                      className="cancel-button m-l-2"
                      type="reset"
                      onClick={prop.handleBack}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              )}
            </div>
          );
        }}
      </Formik>
      <ConfermationModal
        content={
          save
            ? "Do you want reject the issue?"
            : "Do you want approve the issue?"
        }
        visible={conformationVisible}
        cancel={handelCancel}
        confirm={handelConform}
      />
    </div>
  );
}

IssueUpdate.propTypes = {
  values: PropTypes.any,
  handleChange: PropTypes.any,
  handleBlur: PropTypes.any,
  handleSubmit: PropTypes.any,
}
